import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { UsersScreen } from './UsersScreen';
import type { UsersFilters } from './users-query';

const route = getRouteApi('/users');

export function UsersRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onFiltersChange = useCallback(
    (next: UsersFilters) => {
      void navigate({
        // `replace` keeps typing in the search box from filling the history
        // stack with one entry per debounce.
        replace: true,
        // Absent keys rather than explicit undefined, so a cleared filter
        // leaves the URL entirely instead of lingering as `?diet=`.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  const onOpenUser = useCallback(
    (userId: string) => {
      // A push, not a replace: the back button returns to the filtered list.
      void navigate({ to: '/users/$userId', params: { userId }, search: { tab: 'profile' } });
    },
    [navigate],
  );

  return <UsersScreen filters={search} onFiltersChange={onFiltersChange} onOpenUser={onOpenUser} />;
}
